import { render } from "./Alert.vue?vue&type=template&id=7ec7fc96&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=7ec7fc96&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec7fc96"],['__file',"src/assets/js/components/Alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ec7fc96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ec7fc96', __exports__)) {
    api.reload('7ec7fc96', __exports__)
  }
  
  module.hot.accept("./Alert.vue?vue&type=template&id=7ec7fc96&scoped=true", () => {
    api.rerender('7ec7fc96', render)
  })

}


export default __exports__